import React, { useState, useRef, useEffect, createRef } from "react";

import { useTranslation } from "react-i18next";

import ImageFilePreview from "./imageFilePreview";
import Modal from './modal'

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

const ImagePicker = ({ onChange, onRemove, imageUrl, size=240, crop = false, asButton = false }) => {
  const [image, setImage] = useState();
  const [cropImage, setCropImage] = useState(null);

  const inputRef = useRef();
  const { t } = useTranslation();

  const setFile = (file) => {
    setImage(file)
    onChange && onChange(file)
  }

  const handleFile = () => {
    const inputFile = inputRef.current.files[0];
    
    if (!inputFile) {
      setFile(null)
      return
    }
    
    crop ? setCropImage(inputFile) : setFile(inputFile)
  };

  const processCrop = (cropped) => {
    setFile(cropped)
    setCropImage(null)
  }

  const remove = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setImage(null);
    onRemove();
  }

  return (
    <>
      <input type="file" name="file" ref={inputRef} onChange={handleFile} className="image-picker-input" accept='image/*' />
      {
        asButton 
        ? <>
          <button type="button" className="button-save" onClick={() => inputRef.current.click()}>{t('buttons.common.add-image')}</button> 
          { onRemove && (image || imageUrl) && <i className="icon icon-trash pointer" onClick={remove}></i> }
         </>
        : <div className={`image-picker ${(!image || !imageUrl) ? 'empty' : ''}`} onClick={() => inputRef.current.click()} style={{height: size, width: size}} >
            <ImageFilePreview image={image ? image : imageUrl}/>
            <div className="icons">
              <i className="icon icon-pencil"></i>
              { onRemove && (image || imageUrl) && <i className="icon icon-trash" onClick={remove}></i> }
            </div>
          </div> 
      }

      {cropImage && <CropperDialog image={cropImage} onChange={processCrop} />}
    </>

  );
};

export default ImagePicker;

function CropperDialog({ onChange, image }) {
  const [show, setShow] = useState(true);
  const [croppable, setCroppable] = useState(null);
  const cropperRef = createRef();

  const { t } = useTranslation();
  
  useEffect(() => {
    if (image && (image instanceof File || image instanceof Blob)) {
      const reader = new FileReader();
      
      reader.onload = (e) => { setCroppable(e.target.result) };

      image instanceof File ? reader.readAsDataURL(image) : reader.readAsText(image);
    } else {
      setCroppable(image)
    }

  }, [image])

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {

      cropperRef.current?.cropper.getCroppedCanvas().toBlob(function (blob) {
        const lastModified = new Date().getTime();
        const file = new File([blob], `cropped-${lastModified}.jpg`, { type: blob.type, lastModified });

        onChange && onChange(file)
      }, 'image/jpeg');

    }
  };

  const cancel = () => {
    onChange ? onChange(null) : setShow(false)
  }

  return (
    <Modal openModal={show} closeModal={cancel}>
      <div className="flex1 flex-column">
        {croppable && <Cropper
          ref={cropperRef}
          style={{ height: 400, width: "100%" }}
          zoomTo={0.5}
          initialAspectRatio={1}
          aspectRatio={1}
          preview=""
          src={croppable}
          background={false}
        />}
      </div>
      <button className='button-primary' onClick={getCropData}>{t('shared.crop')}</button>
      <button className='button' onClick={cancel}>{t('buttons.common.cancel')}</button>
    </Modal>)

}